import script from "./UPinInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./UPinInput.vue?vue&type=script&setup=true&lang=ts"

import "./UPinInput.vue?vue&type=style&index=0&id=da3af004&lang=css"

const __exports__ = script;

export default __exports__